<header class="app-header navbar" [ngStyle]="bgColor1">
  <div style="display:flex; flex:15%; height:100%; flex-direction:row; align-items:center;">
    <div>
      <button type="button" kendoButton [size]="'large'" [svgIcon]="reorderImage" class="wide-toggle-button" type="button" (click)="toggleSidebar()"></button>
    </div>
    <div style="height:100%">
      <a class="navbar-brand" href={{spmAppUrl}}></a>
    </div>
  </div>
  <div style="flex-basis: 100%">
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item px-3">
        @if (userIsLoggedIn) {
        <app-assetteam-selection></app-assetteam-selection>
        }
      </li>
    </ul>
  </div>

  <div class="d-md-down-none" style="flex:40%; margin:auto;color:rgba(254, 254, 255, 0.945); text-align:center; font-size:28px; font-weight:bold">{{envName}}</div>

  <ul style="flex:50%; flex-direction:row-reverse" class="nav navbar-nav ms-auto">
    <li>&nbsp;</li>
    <li class="nav-item">
      <kendo-menu [openOnClick]="true" (select)="onSelect($event)">
        <kendo-menu-item [svgIcon]="userImage" [text]="userName">
          @if (!userIsLoggedIn) {
          <kendo-menu-item text="Login" (click)="login()"></kendo-menu-item>
          }
          @if (userIsLoggedIn) {
          <kendo-menu-item text="Logout" (click)="logout()"></kendo-menu-item>
          }
        </kendo-menu-item>
      </kendo-menu>
    </li>
    <li class="nav-item">
      <button type="button" kendoButton class="wide-toggle-button" [themeColor]="'base'" [fillMode]="'clear'" [svgIcon]="fullScreenImage" (click)="toggleFullScreen()"></button>
    </li>
  </ul>
</header>